export const TCDD_UNIT = {
  NONE: '',

  // traction system
  CESUR: 'cesur',
  CER_MOTOR: 'cer-motor',

  // signalization system
  ETCS_CABINET: 'etcs-cabinet',
  ETCS_CAB_1: 'etcs-cab-1',
  CABINET_1_RTM: 'cabinet-1-rtm',
  CABINET_1_GSM_R_VOICE_MODULE: 'cabinet-1-gsm-r-voice-module',
  CABINET_2_JRU: 'cabinet-2-jru',
  CABINET_2_PSU: 'cabinet-2-psu',
  CABINET_2_EVC: 'cabinet-2-evc',
  CABINET_2_NVC: 'cabinet-2-nvc',
  CABINET_2_BTM: 'cabinet-2-btm',
  ETCS_CAB_2: 'etcs-cab-2',
  GSM_R_ANTENNA_DATA_1: 'gsm-r-antenna-data-1',
  GSM_R_ANTENNA_DATA_2: 'gsm-r-antenna-data-2',
  GSM_R_ANTENNA_VOICE: 'gsm-r-antenna-voice',
  TACHOMETER_SPEED_SENSOR: 'tachometer-speed-sensor',
  TACHOMETER_SPEED_SENSOR_1: 'tachometer-speed-sensor-1',
  TACHOMETER_SPEED_SENSOR_2: 'tachometer-speed-sensor-2',
  DOPPLER_RADAR: 'doppler-radar',
  DOPPLER_RADAR_1: 'doppler-radar-1',
  DOPPLER_RADAR_2: 'doppler-radar-2',
  BTM_ANTENNA: 'btm-antenna',

  // communication system
  UDS_UIB: 'uds-uib',
  DMI: 'dmi',
  BTM: 'btm',
  JRU: 'jru',
  RTM: 'rtm',
  EVC: 'evc',
  NVC: 'nvc',
  PSU: 'psu',
  EVENT_RECORDER: 'event-recorder',
  BCU: 'bcu',
  TCU: 'tcu',
  WTB_MVB: 'wtb-mvb',
  CCU: 'ccu',
  CCU_UNIT: 'ccu-unit',
  RIOM_1_CCU: 'riom-1-ccu',
  RIOM_2_CCU: 'riom-2-ccu',
  HMI: 'hmi',
  HMI_OK: 'hmi-ok',
  HMI_NOK: 'hmi-nok',
  ACTIVE_CCU: 'activeCcu',
  MVB_EC_POINT: 'mvb-ec-point',
  MVB_CD_POINT: 'mvb-cd-point',
  OA_RIOM_1: 'oa-riom-1',
  OA_RIOM_2: 'oa-riom-2',
  OA3_RIOM_1: 'oa3-riom-1',
  OA3_RIOM_2: 'oa3-riom-2',
  SKA_RIOM_1: 'ska-riom-1',
  SKA_RIOM_2: 'ska-riom-2',
  MVB_RIOM: 'mvb-riom',
  MVB_RIOM_1: 'mvb-riom1',
  MVB_RIOM_2: 'mvb-riom2',
  MVB_RIOM_3: 'mvb-riom3',
  MVB_RIOM_4: 'mvb-riom4',
  CAN_RIOM: 'can-riom',
  PAPIS: 'papis',
  CCTV: 'cctv',
  OA1_CAN_RIOM: 'oa1-can-riom',
  OA1_MVB_RIOM: 'oa1-mvb-riom',
  OA1_1_CAN_RIOM: 'oa1_1-can-riom',
  OA1_1_MVB_RIOM: 'oa1_1-mvb-riom',
  OA2_CAN_RIOM: 'oa2-can-riom',
  OA2_MVB_RIOM: 'oa2-mvb-riom',
  OA3_CAN_RIOM: 'oa3-can-riom',
  OA3_MVB_RIOM: 'oa3-mvb-riom',

  // brake system
  PARKING_BRAKE: 'parkingBrake',
  EMERGENCY_BRAKE: 'emergencyBrake',
  INDIRECT_BRAKE: 'indirectBrake',
  BRAKE_TB: 'brakeTB',
  BRAKE_MB: 'brakeMB',
  TEXT_BRAKE_TB: 'text-brakeTB',
  TEXT_BRAKE_MB: 'text-brakeMB',

  // power voltage system
  PANTOGRAPH: 'pantograph',
  PANTOGRAPH_UP: 'pantograph-up',
  PANTOGRAPH_DOWN: 'pantograph-down',
  TRANSFORMER: 'transformer',
  BATTERY: 'battery',

  // air condition system
  ALL_HVAC: 'hvac-1/2/driver',
  HVAC_1_AND_HVAC_2: 'hvac-1/2',
  DRIVER_HVAC: 'driver-hvac',
  HVAC_1: 'hvac-1',
  HVAC_2: 'hvac-2',
  TEXT_DRIVER_HVAC_TRAIN: 'text-driver-hvac-train',
  TEXT_HVAC_1_TRAIN: 'text-hvac-1-train',
  TEXT_HVAC_2_TRAIN: 'text-hvac-2-train',
  TEXT_DRIVER_HVAC_WAGON: 'text-driver-hvac-wagon',
  TEXT_HVAC_1_WAGON: 'text-hvac-1-wagon',
  TEXT_HVAC_2_WAGON: 'text-hvac-2-wagon',

  // door system
  OUTER_DOOR_1: 'outer-door-1',
  OUTER_DOOR_2: 'outer-door-2',
  OUTER_DOOR_3: 'outer-door-3',
  OUTER_DOOR_4: 'outer-door-4',
  END_DOOR_1: 'end-door-1',
  END_DOOR_2: 'end-door-2',
  INNER_DOOR_1: 'inner-door-1',
  INNER_DOOR_2: 'inner-door-2',
  BISTRO_DOOR: 'bistro-door',
  PRM_DOOR_1: 'prm-door-1',
  PRM_DOOR_2: 'prm-door-2',

  // other system
  OUTDOOR_LIGHTING: 'outdoor-lighting',
  SKA1_OUTDOOR_LIGHTING_LEFT: 'ska1-outdoor-lighting-left-icon',
  SKA1_OUTDOOR_LIGHTING_RIGHT: 'ska1-outdoor-lighting-right-icon',
  SKA1_OUTDOOR_LIGHTING_UP: 'ska1-outdoor-lighting-up-icon',
  SKA2_OUTDOOR_LIGHTING_LEFT: 'ska2-outdoor-lighting-left-icon',
  SKA2_OUTDOOR_LIGHTING_RIGHT: 'ska2-outdoor-lighting-right-icon',
  SKA2_OUTDOOR_LIGHTING_UP: 'ska2-outdoor-lighting-up-icon',
  INTERIOR_LIGHTING: 'interior-lighting-icon',
  FIRE_EXTINGUISHER: 'fire-extinguisher',
  PASSENGER_ALARM: 'passenger-alarm',
  PASSENGER_ALARM_1: 'passenger-alarm-1',
  PASSENGER_ALARM_2: 'passenger-alarm-2',
  PASSENGER_ALARM_3: 'passenger-alarm-3',
  PASSENGER_ALARM_4: 'passenger-alarm-4',
  TOILET: 'toilet',
  TOILET_BACKGROUND: 'toilet-background',
  TOILET_TEXT: 'toilet-text',
  TOILET_CONTAINER: 'toilet-container',
  TOILET_SOS_CONTAINER: 'toilet-sos-container',

  // main system
  COUPLER: 'coupler',
  DIRECTION: 'direction',
  ACTIVE_CAB_CONTAINER: 'active-cab-container',
  TITLE_ICON: 'title-icon',
  TEXT_TITLE: 'text-title'
} as const;
